/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChallengeDataFragment = {
  readonly __typename?: 'Challenge';
  readonly achieved: number;
  readonly celebrationCopy: string;
  readonly descriptiveTitle: string;
  readonly expirationDate: any;
  readonly goal: number;
  readonly id: string;
  readonly legalTerms: string;
  readonly percentageCompleted: number;
  readonly permalink: string;
  readonly progress: number;
  readonly progressCopy: string;
  readonly status: Types.ChallengeStatus;
  readonly title: string;
};

export type ChallengesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ChallengesQuery = {
  readonly __typename?: 'Query';
  readonly challenges: ReadonlyArray<{
    readonly __typename?: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
  }>;
};

export type ChallengesWithThemeQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ChallengesWithThemeQuery = {
  readonly __typename?: 'Query';
  readonly challenges: ReadonlyArray<{
    readonly __typename?: 'Challenge';
    readonly theme: Types.ChallengeTheme;
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
  }>;
};

export type ChallengeOptInMutationVariables = Types.Exact<{
  challengeId: Types.Scalars['String'];
}>;

export type ChallengeOptInMutation = {
  readonly __typename?: 'Mutation';
  readonly challengeOptIn: {
    readonly __typename?: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
  };
};

export type ChallengeWithThemeOptInMutationVariables = Types.Exact<{
  challengeId: Types.Scalars['String'];
}>;

export type ChallengeWithThemeOptInMutation = {
  readonly __typename?: 'Mutation';
  readonly challengeOptIn: {
    readonly __typename?: 'Challenge';
    readonly theme: Types.ChallengeTheme;
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
  };
};

export const challengesQueryMock: ExecutionResult<ChallengesQuery> = {
  data: {
    challenges: [
      {
        achieved: -27.84,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -95.27,
        id: '9e6ea9fe-e42a-4996-a587-ce71904308da',
        legalTerms: 'Hello World',
        percentageCompleted: -10.27,
        permalink: 'Hello World',
        progress: 27.95,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
      {
        achieved: -11.63,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -85.61,
        id: '63ba7eda-96e8-4a18-9e3d-a00a9a475343',
        legalTerms: 'Hello World',
        percentageCompleted: -81.97,
        permalink: 'Hello World',
        progress: 14.41,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
      {
        achieved: 70.04,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -89.93,
        id: '8060b59a-a250-4f9c-8016-b1bd634cb273',
        legalTerms: 'Hello World',
        percentageCompleted: 47.05,
        permalink: 'Hello World',
        progress: -10,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
    ],
  },
};

export const challengesWithThemeQueryMock: ExecutionResult<ChallengesWithThemeQuery> =
  {
    data: {
      challenges: [
        {
          achieved: 13.25,
          celebrationCopy: 'Hello World',
          descriptiveTitle: 'Hello World',
          expirationDate: 'DateTime',
          goal: 89.76,
          id: '18d030f1-b1f2-4c49-b5fd-7994ccdcab38',
          legalTerms: 'Hello World',
          percentageCompleted: 46.49,
          permalink: 'Hello World',
          progress: -2.98,
          progressCopy: 'Hello World',
          status: 'COMPLETED',
          title: 'Hello World',
          theme: 'DEFAULT',
        },
        {
          achieved: -49.48,
          celebrationCopy: 'Hello World',
          descriptiveTitle: 'Hello World',
          expirationDate: 'DateTime',
          goal: 6.79,
          id: '5afbe885-32ed-4e7a-9daa-933e0e095a7b',
          legalTerms: 'Hello World',
          percentageCompleted: -46.09,
          permalink: 'Hello World',
          progress: 2.38,
          progressCopy: 'Hello World',
          status: 'COMPLETED',
          title: 'Hello World',
          theme: 'DEFAULT',
        },
        {
          achieved: 97.64,
          celebrationCopy: 'Hello World',
          descriptiveTitle: 'Hello World',
          expirationDate: 'DateTime',
          goal: -99.12,
          id: 'bb560d01-80d3-49ca-8c05-20a352a4a654',
          legalTerms: 'Hello World',
          percentageCompleted: -83.1,
          permalink: 'Hello World',
          progress: 46.76,
          progressCopy: 'Hello World',
          status: 'COMPLETED',
          title: 'Hello World',
          theme: 'DEFAULT',
        },
      ],
    },
  };

export const challengeOptInMutationMock: ExecutionResult<ChallengeOptInMutation> =
  {
    data: {
      challengeOptIn: {
        achieved: -33.01,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: 48.63,
        id: 'c5d089f5-2e92-41d9-9bfd-fbabd38fdf8e',
        legalTerms: 'Hello World',
        percentageCompleted: 46.05,
        permalink: 'Hello World',
        progress: -82.52,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
      },
    },
  };

export const challengeWithThemeOptInMutationMock: ExecutionResult<ChallengeWithThemeOptInMutation> =
  {
    data: {
      challengeOptIn: {
        achieved: -31.13,
        celebrationCopy: 'Hello World',
        descriptiveTitle: 'Hello World',
        expirationDate: 'DateTime',
        goal: -93.9,
        id: '587b384c-4829-49be-911f-9b1e39b6d74a',
        legalTerms: 'Hello World',
        percentageCompleted: 88.24,
        permalink: 'Hello World',
        progress: 40.15,
        progressCopy: 'Hello World',
        status: 'COMPLETED',
        title: 'Hello World',
        theme: 'DEFAULT',
      },
    },
  };
export const ChallengeDataFragmentDoc = gql`
  fragment ChallengeData on Challenge {
    achieved
    celebrationCopy
    descriptiveTitle
    expirationDate
    goal
    id
    legalTerms
    percentageCompleted
    permalink
    progress
    progressCopy
    status
    title
  }
`;
export const ChallengesDocument = gql`
  query Challenges {
    challenges {
      ...ChallengeData
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengesQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChallengesQuery, ChallengesQueryVariables>({
    query: ChallengesDocument,
    ...options,
  });
}
export const ChallengesWithThemeDocument = gql`
  query ChallengesWithTheme {
    challenges {
      ...ChallengeData
      theme
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengesWithThemeQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengesWithThemeQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    ChallengesWithThemeQuery,
    ChallengesWithThemeQueryVariables
  >({ query: ChallengesWithThemeDocument, ...options });
}
export const ChallengeOptInDocument = gql`
  mutation challengeOptIn($challengeId: String!) {
    challengeOptIn(challengeId: $challengeId) {
      ...ChallengeData
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengeOptInMutation() {
  return Urql.useMutation<
    ChallengeOptInMutation,
    ChallengeOptInMutationVariables
  >(ChallengeOptInDocument);
}
export const ChallengeWithThemeOptInDocument = gql`
  mutation challengeWithThemeOptIn($challengeId: String!) {
    challengeOptIn(challengeId: $challengeId) {
      ...ChallengeData
      theme
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengeWithThemeOptInMutation() {
  return Urql.useMutation<
    ChallengeWithThemeOptInMutation,
    ChallengeWithThemeOptInMutationVariables
  >(ChallengeWithThemeOptInDocument);
}
